
import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface BlogManagementHeaderProps {
  onAIDialogOpen: () => void;
  onCreatePost: () => void;
  searchTerm: string;
  onSearch: (term: string) => void;
}

const BlogManagementHeader: React.FC<BlogManagementHeaderProps> = ({
  onAIDialogOpen,
  onCreatePost,
  searchTerm,
  onSearch,
}) => {
  return (
    <>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-bold">Blog Management</h1>
          <p className="text-gray-600">
            Manage your blog posts, schedule publications, and generate content with AI
          </p>
        </div>
        <div className="flex space-x-2">
          <Button variant="outline" onClick={onAIDialogOpen}>
            AI Generate Blog
          </Button>
          <Button onClick={onCreatePost}>Create New Post</Button>
        </div>
      </div>
      
      <div className="mb-6">
        <Input
          placeholder="Search posts by title, category or author..."
          value={searchTerm}
          onChange={(e) => onSearch(e.target.value)}
          className="max-w-md"
        />
      </div>
    </>
  );
};

export default BlogManagementHeader;
